<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <container align="center">
          <btn
            :bg-color="$root.colors.primary"
            :bg-color-lightness="$root.colors.bgColorLightness"
            color="white"
            icon-left="cookie"
            :color-lightness="null"
            @click="$root.cookieConsent = !$root.cookieConsent"
          >{{ $lang.toggleComponent($root.cookieConsent, 'Cookie Consent') }}</btn>
        </container>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageCookieConsent'
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/cookie-consent.vue